import template from "./settings-expiration-period.html";

const SettingsExpirationPeriodComponent = {
  template: template,
  controller: class SettingsExpirationPeriodController {
    /* @ngInject */
    constructor($rootScope, $state, $filter, Organization, OrganizationService, Notification) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$filter = $filter;
      this.Organization = Organization;
      this.OrganizationService = OrganizationService;
      this.NotificationService = Notification;
    }

    $onInit() {
      this.organization = new this.Organization(this.$rootScope.organization);
      this.saving = false;
    }

    save() {
      if (this.form.$valid) {
        this.saving = true;
        this.OrganizationService.updateOrganization(this.organization).then(
          (organization) => {
            this.NotificationService.success({
              title: this.$filter("trans")("notificationService.title.success"),
              message: this.$filter("trans")("notificationService.message.setExpirationPeriod"),
            });
            this.organization = new this.Organization(organization);
            this.saving = false;
            this.$state.reload();
          },
          () => {
            this.saving = false;
          },
        );
      }
    }
  },
};

export default SettingsExpirationPeriodComponent;
